module.exports = __webpack_public_path__ + "img/intro-header.06cc5416.png";